import React, { useEffect, useState } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { green, red2, yellow } from 'app/components/ThemeProvider/colors';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import logger from 'app/utils/logger';
import { useGetAccount } from 'app/utils/services/accountService';
import { useChangeCardStatus, useChangeSmsNotif, useGetCard } from 'app/utils/services/cardService';
import { getTheme } from 'app/components/ThemeProvider/theme';

const statusFilterBtns = [
  {
    id: 1,
    title: 'Hamısı',
  },
  {
    id: 2,
    title: 'Aktiv',
    icon: <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: green }}></Box>,
  },
  {
    id: 3,
    title: 'Bloklaşdırılmış',
    icon: <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: yellow }}></Box>,
  },
  {
    id: 4,
    title: 'VÖEN',
  },
  {
    id: 5,
    title: 'Mobil',
    icon: <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: green }}></Box>,
  },
  {
    id: 6,
    title: 'Elektron poçt',
    icon: <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: yellow }}></Box>,
  },
];
const paymentStatus = [
  {
    value: 'active',
    label: 'Aktiv',
    icon: <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: green }}></Box>,
  },
  {
    value: 'blocked',
    label: 'Bloklaşdırılmış',
    icon: <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: yellow }}></Box>,
  },
  {
    value: 'closed',
    label: 'Bağlı',
    icon: <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: red2 }}></Box>,
  },
];

const cardsInfo = [
  {
    id: 1,
    headerText: 'Biznes kart',
    accountText: 'AZ88NICB00600982750001A40060',
    amount: '16780.36 ₼',
    cardNumber: '4369 3123 2780 3274',
    expireDate: '01/26',
    status: paymentStatus[0],
  },
  {
    id: 2,
    headerText: 'Biznes kart',
    accountText: 'AZ88NICB00600982750001A40060',
    amount: '16780.36 ₼',
    cardNumber: '4369 3123 2780 3274',
    expireDate: '01/26',
    status: paymentStatus[1],
  },
  {
    id: 3,
    headerText: 'Biznes kart',
    accountText: 'AZ88NICB00600982750001A40060',
    amount: '16780.36 ₼',
    cardNumber: '4369 3123 2780 3274',
    expireDate: '01/26',
    status: paymentStatus[0],
  },
];

const filterBtns = [
  { id: 1, title: 'Hesablar', route: 'accounts' },
  { id: 2, title: 'Kartlar', route: 'cards' },
  // { id: 3, title: 'Ani ödənişlər sistemi', route: 'instant-payments-sign-up' },
];

const useAccountCardsPage = () => {
  const [btnId, setBtnId] = useState(1);
  const [statusBtnId, setStatusBtnId] = useState(1);
  const [value, setSelectValue] = useState('');

  const [account, setAccount] = useState([]);
  const [card, setCard] = useState([]);

  const navigate = useNavigate();

  const location = useLocation();
  const lang = location.pathname.substring(0, 3);

  const [searchParams] = useSearchParams();
  const pageType = searchParams.get('type');

  const [instantRegist, setInstantRegister] = useState(false);
  const [phoneVerifyModal, setPhoneVerifyModal] = useState(false);
  const theme = getTheme('light');

  const largeScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const tabletScreen = useMediaQuery(theme.breakpoints.down(768));
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [aliasAddModal, setAliasAddModal] = useState(false);

  const [aliasValue, setAliasValue] = useState('');
  const [accountsModal, setAccountsModal] = useState(false);

  // const [accountsCount, setAccountsCount] = useState(0);
  const [accountData, setAccountData] = useState([]);
  const [cardData, setCardData] = useState([]);
  const [smsNotif, setSmsNotif] = useState([]);
  const [blockCard, setBlockCard] = useState([]);

  const { isLoadingGetDataAccount, refetchGetDataAccount, dataGetAccount } = useGetAccount();
  const { isLoadingGetDataCard, refetchGetDataCard, dataGetCard } = useGetCard();
  const { isLoadingSmsNotif, smsNotifMutation, dataSmsNotif } = useChangeSmsNotif();
  const { isLoadingCardStatus, cardStatusMutation, dataCardStatus } = useChangeCardStatus();

  useEffect(() => {
    // setAccountsCount(dataGetAccount?.accounts.length);
    setAccountData(dataGetAccount?.accounts);
  }, [dataGetAccount]);

  useEffect(() => {
    setCardData(dataGetCard?.accounts);
    for (let i = 0; i < dataGetCard?.accounts.length; i++) {
      setSmsNotif((prevState) => [...prevState, dataGetCard?.accounts[i].sms_notification]);
      // if (dataGetCard?.card_list[i].smsNotification === '1') {
      //
      // setSmsNotif([...smsNotif, true]);
      // } else {
      // setSmsNotif([...smsNotif, false]);
      // }
      setBlockCard((prevState) => [...prevState, dataGetCard?.accounts[i].state]);
    }
  }, [dataGetCard]);

  logger.log('hey');

  useEffect(() => {
    if (pageType === 'cards') {
      refetchGetDataCard();
      // setBtnId(2);
    }
    if (pageType === 'accounts') {
      refetchGetDataAccount();
      // setBtnId(1);
    }
  }, [pageType]);

  const handleChangePageType = (id: number) => {
    setBtnId(id);
    navigate(`${lang}/accounts-card?type=${filterBtns[id - 1].route}`);
  };

  const accountOnChange = (newValue: any) => {
    setSelectValue(newValue);
  };

  const cardOnChange = (newValue: any) => {
    setSelectValue(newValue);
  };

  const handleCardOrder = () => {
    navigate(`${lang}/card-order`);
  };

  const handleSwitchSMS = (index: any) => {
    const newArr = smsNotif;
    newArr[index] = newArr[index] === '1' ? '0' : '1';
    setSmsNotif(newArr);
    smsNotifMutation({
      data: {
        card_no: dataGetCard?.accounts[index].cardNo,
        account_no: dataGetCard?.accounts[index].iban,
        card_sms_notification: dataGetCard?.accounts[index].state === '1' ? 'disable' : 'enable',
      },
    });
  };

  const handleSwitchBlock = (index: any) => {
    const newArr = blockCard;
    newArr[index] = newArr[index] === 'ACTIVE' ? 'BLOCKED' : 'ACTIVE';
    setBlockCard(newArr);
    cardStatusMutation({
      data: {
        card_no: dataGetCard?.accounts[index].cardNo,
        account_no: dataGetCard?.accounts[index].iban,
        card_status: dataGetCard?.accounts[index].smsNotification === 'ACTIVE' ? 'blocked' : 'active',
      },
    });
  };

  const handleCardStatus = (iban: any, cardNo: any, cardStatus: any) => {
    cardStatusMutation({
      data: {
        card_no: cardNo,
        account_no: iban,
        card_status: cardStatus === 'ACTIVE' ? 'blocked' : 'active',
      },
    });
  };

  useEffect(() => {
    if (pageType === null || pageType === 'accounts') {
      setBtnId(1);
      // refetchGetDataAccount();
    } else if (pageType === 'cards') {
      setBtnId(2);
      // refetchGetDataCard();
    } else if (pageType === 'instant-payments') {
      setBtnId(3);
    }
  }, []);

  return {
    filterBtns,
    btnId,
    setBtnId,
    account,
    accountOnChange,
    cardOnChange,
    statusFilterBtns,
    statusBtnId,
    setStatusBtnId,
    handleChangePageType,
    pageType,
    cardsInfo,
    card,
    handleCardOrder,
    isLoadingGetDataAccount,
    dataGetAccount,
    // accountsCount,
    dataGetCard,
    isLoadingGetDataCard,
    accountData,
    setAccountData,
    cardData,
    smsNotif,
    handleSwitchSMS,
    setSmsNotif,
    handleCardStatus,
    setInstantRegister,
    instantRegist,
    largeScreen,
    tabletScreen,
    smallScreen,
    phoneVerifyModal,
    setPhoneVerifyModal,
    aliasAddModal,
    setAliasAddModal,
    aliasValue,
    setAliasValue,
    accountsModal,
    setAccountsModal,
    setCardData,
    blockCard,
    handleSwitchBlock,
  };
};

export default useAccountCardsPage;
